module.exports = __webpack_public_path__ + "static/media/placeholderCEV.96525ce1.png";